import React from "react";
import ChangePasswordForm from "../../components/ChangePassword/ChangePassword";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../contexts/Auth/AuthContext";
import { useContext } from "react";

const ChangePassword = () => {
  const navigate = useNavigate();
  const auth = useContext(AuthContext);

  const handleSuccess = () => {
    // Após alterar senha com sucesso, redirecionar para home
    navigate("/autentico/home");
  };

  const handleCancel = () => {
    // Se cancelar, fazer logout
    auth.signout();
    navigate("/");
  };

  if (!auth.user || !auth.user.id) {
    // Se não houver usuário, redirecionar para login
    navigate("/");
    return null;
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "24px 16px",
        background:
          "linear-gradient(135deg, #1e958c 0%, #0b4f6c 45%, #ffffff 100%)",
      }}
    >
      <ChangePasswordForm
        userId={auth.user.id}
        onSuccess={handleSuccess}
        onCancel={handleCancel}
      />
    </div>
  );
};

export default ChangePassword;










